import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context) || {}
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder || []

const QUERY = gql`
  query ServiceOrder($id: ID) {
    serviceOrder(id: $id) {
      id
      place {
        id
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      address {
        search
        latitude
        longitude
      }
      user {
        id
        name
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      status {
        id
        name
      }
    }
  }
`

const ServiceOrdersToEditLoader = ({ children, uncontrolledChildren }) => {
  const { data: id } = useCurrentModal()
  const { data, ...state } = useQuery(QUERY, {
    variables: {
      id: id
    },
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default ServiceOrdersToEditLoader
